exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".threads-st1 {\n  fill:#FFFFFF;\n}\n\n", ""]);
